export const DETAILS_DRAWER_Z_INDEX = 9999;
export const DETAILS_DRAWER_HEADER_HEIGHT = 90;
export const DETAILS_DRAWER_CONTROLLER_HEIGHT = 75;
